import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import filters from './services/filters'
import VueGeolocation from 'vue-browser-geolocation'
import './sass/general.scss'

Vue.use(filters)
Vue.use(VueGeolocation)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    methods: {
        async pushNotification(data) {
            await store.dispatch('notification/push', data)
        },
    },
    render: h => h(App),
}).$mount('#app')
